<template>
  <div>
    <Header title="学生评教" type="0" route="/homeIndex"></Header>
    <NOdata
      v-if="JSON.stringify(list) == '[]'"
      title="暂无评价批次数据"
    ></NOdata>
    <div v-else class="bkEvaluateIndex">
      <div
        class="list-item info"
        v-for="(item, index) of list"
        :key="index"
        @click="goItem(item)"
      >
        <p>{{ item.pjpcmc }}</p>
        <ul>
          <li>评价分类：{{ item.pjflmc }}</li>
          <li>开始时间：{{ item.kssj }}</li>
          <li>结束时间：{{ item.jssj }}</li>
          <li>学年学期：{{ item.xqmc }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    goItem(item) {
      this.$router.push({
        path: "/bk/xspjItem",
        query: {
          list: item
        }
      });
    },
    async getList() {
      const res = await Api.xspj_find();
      if (res.code == "1") {
        this.list = res.data;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.bkEvaluateIndex {
  padding: 0 20px;
  .list-item {
    background: #f8f8f8;
    border-radius: 5px;
    margin: 0 auto 5%;
    padding: 3% 0 3% 6%;
    position: relative;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      margin-bottom: 2%;
      font-weight: bold;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #757da3;
      letter-spacing: 0;
      margin-bottom: 1%;
    }
    span {
      width: 70px;
      height: 42px;
      background: #7469f8;
      border-radius: 3px;
      position: absolute;
      top: 10%;
      right: 3%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/bkEvaluate/index.vue